import * as Constants from '../constants'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./ContatoPage.module.css";
import { faShare } from "@fortawesome/free-solid-svg-icons";
import { useState, useRef } from "react";
import Swal from 'sweetalert2';
import { Turnstile } from "@marsidev/react-turnstile";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function ContatoPage() {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [honeypot, setHoneypot] = useState(""); // campo "f": isca para robôs
  const [isLoading, setIsLoading] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const [token, setToken] = useState(null);
  const turnstileRef = useRef(null);

  const messageDialog = (message, type = 'warning') => {
    Swal.fire({
      title: type === 'warning' ? 'Atenção!' : type === 'success' ? 'Sucesso!' : 'Falha!',
      text: message,
      icon: type,
      confirmButtonText: 'FECHAR',
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {
          Object.assign(confirmButton.style, {
            padding: '10px 40px',
            fontSize: '18px',
            fontWeight: '600',
            backgroundColor: '#00FF08',
            border: '0',
            borderRadius: '30px',
            cursor: 'pointer',
            transition: '.2s',
            color: '#000'
          });
        }
      }
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    const dados = {
      nome: nome.trim(),
      email: email.trim(),
      telefone: telefone.trim(), // string vazia (URLSearchParams converteria null em "null")
      mensagem: mensagem.trim(),
      f: honeypot.trim(),
    };

    // 1) Validações ANTES de abrir o "Enviando..."
    if (!dados.nome) {
      messageDialog('Por favor, informe o seu nome.');
      form.elements.nome.focus();
      return;
    }

    if (!dados.email) {
      messageDialog('Por favor, preencha o e-mail.');
      form.elements.email.focus();
      return;
    }

    if (!EMAIL_REGEX.test(dados.email)) {
      messageDialog('Por favor, informe um e-mail válido.');
      form.elements.email.focus();
      return;
    }

    if (!dados.mensagem) {
      messageDialog('Por favor, digite a sua mensagem.');
      form.elements.mensagem.focus();
      return;
    }

    if (!token) {
      messageDialog('Confirme que você não é um robô.');
      return;
    }

    // 2) Envio
    setIsLoading(true);
    Swal.fire({
      title: "Enviando mensagem!",
      text: "Aguarde...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      backdrop: true
    });

    try {
      // O navegador define o Content-Type (application/x-www-form-urlencoded) sozinho
      const response = await fetch(Constants.CONTACT, {
        method: 'POST',
        body: new URLSearchParams({ ...dados, turnstileToken: token }),
      });

      // Protege contra respostas em HTML (ex.: erro do PHP)
      const contentType = response.headers.get("content-type") || "";
      if (!contentType.includes("application/json")) {
        const textoErro = await response.text();
        throw new Error(`Servidor não retornou JSON. Resposta: ${textoErro.substring(0, 100)}...`);
      }

      const responseJson = await response.json();

      if (!response.ok || !responseJson.sucesso) {
        throw new Error(responseJson.message || `Erro HTTP ${response.status}`);
      }

      Swal.close();
      messageDialog('Mensagem enviada com sucesso.', 'success');
      setNome("");
      setEmail("");
      setTelefone("");
      setMensagem("");
      setHoneypot("");
      setMessageSent(true);
    } catch (error) {
      console.error('Erro na requisição:', error.message || error);
      Swal.close();
      messageDialog('Não foi possível enviar a mensagem. Tente novamente.', 'error');
    } finally {
      // Sempre libera o botão e gera um novo token (o token é de uso único,
      // inclusive quando o envio falha)
      setIsLoading(false);
      turnstileRef.current?.reset();
      setToken(null);
    }
  };

  return (
    <main>
      <section id="contato" className={classes.formulario}>
        <div className="interface">
          <h2 className="titulo">FALE<span> CONOSCO.</span></h2>

          {!messageSent &&
            <form onSubmit={handleSubmit} noValidate>
              <input
                type="text"
                name="nome"
                id="nome"
                value={nome}
                placeholder="* Seu nome"
                onChange={(e) => setNome(e.target.value)}
                disabled={isLoading}
              />
              <input
                type="email"
                name="email"
                id="email"
                value={email}
                placeholder="* Seu e-mail"
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
              />
              <input
                type="text"
                name="telefone"
                id="telefone"
                value={telefone}
                placeholder="Seu celular"
                onChange={(e) => setTelefone(e.target.value.replace(/\D/g, "").slice(0, 13))}
                disabled={isLoading}
                maxLength={13}
              />
              <textarea
                name="mensagem"
                id="mensagem"
                value={mensagem}
                placeholder="* Sua mensagem"
                onChange={(e) => setMensagem(e.target.value)}
                disabled={isLoading}
              ></textarea>

              <Turnstile
                ref={turnstileRef}
                siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                onSuccess={setToken}
                onExpire={() => setToken(null)}
                onError={() => setToken(null)}
              />

              <div className={classes.btnEnviar}>
                <div className={`btnContato ${classes.btnContato}`}>
                  <button type="submit" disabled={isLoading || !token}>
                    <FontAwesomeIcon icon={faShare} />&nbsp;&nbsp;ENVIAR
                  </button>
                </div>
              </div>
            </form>
          }

          {messageSent &&
            <div className='col-md-12 text-center pt-3'><br /><br /><br /><br />
              <h5 className='text-light'>Mensagem enviada com sucesso!</h5>
              <span className='text-light'>Agradecemos o contato e o interesse em nossos serviços.<br />
                Em breve, nossa equipe retornará para dar continuidade ao seu atendimento.</span>
            </div>
          }

        </div>
      </section>
      <br />
    </main>
  );
}

export default ContatoPage;